


























































































































import {
  defineComponent,
  ref,
  useContext,
  useFetch,
} from '@nuxtjs/composition-api'
import { encodeName,doubleDecodeURI } from '~/lib/utilities'
import { BlockNewsItem } from '~/types/blog'

export default defineComponent({
  name: 'BlocksNewsCols3',

  inheritAttrs: false,

  props: {
    data: {
      type: Object,
      default: () => {},
    },
    title: {
      type: String,
      default: '',
    },
  },

  setup(props) {
    const newsItems = ref<BlockNewsItem[]>([])
    const { i18n } = useContext()

    const getSummary = (content: string) => {
      const text = content?.replace(/<[^>]*>/g, '') ?? ''
      return text.length > 275 ? `${text.slice(0, 275)}...` : text
    }

    const getNewsItems = () => {
      const newsItemCategoryId = props.data?.NewsItemCategoryID
      const newsItemsData = props.data?.NewsItems

      if (!newsItemCategoryId && !newsItemsData?.length) {
        // eslint-disable-next-line no-console
        console.error('NewsItemCategoryID or newsItems is missing')
      }

      if (newsItemCategoryId) {
        // get newsItems by api
      }

      if (newsItemsData?.length) {
        newsItems.value = newsItemsData.map((news: any) => ({
          id: news.ID,
          title: doubleDecodeURI(news.Title),
          imageUrl: news.ImageUrl,
          url: news.Url,
          heading: doubleDecodeURI(news.Heading),
          tags: news.Tags
            ? news.Tags?.split('|')?.map((tag: string) => doubleDecodeURI(tag.trim()))
            : [],
          text: doubleDecodeURI(getSummary(news.Text)),
          summary: doubleDecodeURI(getSummary(news.Summary)),
          publicationDate: news.PublicationDate,
          linkTitle: doubleDecodeURI(news.linkTitle || i18n.t('text.readMore')),
        }))
      }
    }

    useFetch(() => {
      getNewsItems()
    })

    const getUrl = (url: string) => {
      return encodeName(url) as string
    }

    return {
      newsItems,
      getUrl,
    }
  },
})
